import request from '@/utils/request' 

export function getLogin(){
    return request({
        url:'user/getWeChatLoginUrl',
        method:'get',
    })
}

// 注销账户
export function cancleAccount(){
    return request({
        url:'user/logout',
        method:'get',
    })
}

// 不知道(问后端，貌似是为了解决公钥私钥的问题)
export function loginFromUnified(params){
    return request({
        url:'user/loginFromUnified',
        params,
        method:'get',
    })
}

